import api from "./httpService";

export const addPackageService = async (payload: any) => {
    const response = await api.post('/packages', payload);
    return response.data;
}
export const getPackages = async () => {
    const response = await api.get("/packages");
    return response.data;
};

export const getPackageMonthlyAnalytics = async (month?: string) => {
    const query = new URLSearchParams();
    if (month) query.set("month", month);

    const response = await api.get(`/packages/analytics/monthly${query.toString() ? `?${query.toString()}` : ""}`);
    return response.data;
};

export const updatePackageService = async (packageId: string, payload: any) => {
    const response = await api.put(`/packages/${packageId}`, payload);
    return response.data;
};

export const deletePackageService = async (packageId: string) => {
    const response = await api.delete(`/packages/${packageId}`);
    return response.data;
};
